export const BLOCK_FAMILIAR = 'BLOCK_FAMILIAR';
export const BLOCK_FAMILIAR_SUCCESS= 'BLOCK_FAMILIAR_SUCCESS';
export const BLOCK_FAMILIAR_ERROR ='BLOCK_FAMILIAR_ERROR';